import React, { forwardRef } from 'react';
import './ScrollableContainer.css';

export interface ScrollableContainerProps {
  children: React.ReactNode;
  className?: string;
  maxHeight?: string | number;
  maxWidth?: string | number;
  direction?: 'vertical' | 'horizontal' | 'both';
  showScrollbar?: boolean;
  scrollbarSize?: 'thin' | 'medium' | 'thick';
  onScroll?: (event: React.UIEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
}

const ScrollableContainer = forwardRef<HTMLDivElement, ScrollableContainerProps>(
  ({
    children,
    className = '',
    maxHeight = '100%',
    maxWidth = '100%',
    direction = 'vertical',
    showScrollbar = true,
    scrollbarSize = 'thin',
    onScroll,
    style,
    ...props
  }, ref) => {
    const containerStyle: React.CSSProperties = {
      maxHeight: typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,
      maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
      overflowX: direction === 'horizontal' || direction === 'both' ? 'auto' : 'hidden',
      overflowY: direction === 'vertical' || direction === 'both' ? 'auto' : 'hidden',
      ...style,
    };

    const containerClasses = [
      'scrollable-container',
      `scrollable-${direction}`,
      `scrollbar-${scrollbarSize}`,
      showScrollbar ? 'scrollbar-visible' : 'scrollbar-hidden',
      className
    ].filter(Boolean).join(' ');

    return (
      <div
        ref={ref}
        className={containerClasses}
        style={containerStyle}
        onScroll={onScroll}
        {...props}
      >
        {children}
      </div>
    );
  }
);

ScrollableContainer.displayName = 'ScrollableContainer';

export default ScrollableContainer;
